// extracted by mini-css-extract-plugin
module.exports = {"datePickerFallback":"DatePickerFallback__datePickerFallback___ge6sY","dateInput":"DatePickerFallback__dateInput___1ZTIg","plusIcon":"DatePickerFallback__plusIcon___1BoX9"};